export default __webpack_public_path__ + "static/media/icon_mh.53bff9e6.png";